import React from 'react';
import { Outlet } from 'react-router-dom';
import { BottomNav } from './BottomNav';
export function AppLayout() {
  return <div className="flex min-h-screen w-full items-center justify-center bg-slate-100 sm:p-6" data-id="element-90" data-mp="1wgu1wleqcm72">
      <div className="relative flex h-screen w-full max-w-[430px] flex-col overflow-hidden bg-[#F8FAFB] sm:h-[860px] sm:rounded-[2.75rem] sm:border sm:border-slate-200 sm:shadow-2xl" data-id="element-91" data-mp="1rf4o4y04hufa">
        <div className="relative min-h-0 flex-1 overflow-hidden" data-id="element-92" data-mp="1igt2lae45mtp">
          <Outlet data-id="element-93" data-mp="1dp16kkc6uow6" />
        </div>
        <BottomNav data-id="element-94" data-mp="1dnzx2katmagk" />
      </div>
    </div>;
}